<template>
  <div>
    <headerNav title="下级充值单据详情" />

    <div class="mian-list">
         <div class="mian-list-info">
           <div class="mian-list-pic">
                <img  v-lazy="$baseurl+model.proofPath">
            </div>
            <div class="main-list-info-main">
              <div class="mian-list-info-data min-height">

                <van-tag type="primary"  class="mian-list-info-left-tag" v-if="model.productType==1" size="medium">大货</van-tag>
                <van-tag type="primary" class="mian-list-info-left-tag" v-if="model.productType==2" size="medium">物料</van-tag>

                <van-tag
                    type="primary"
                    v-if="model.isAudit==0"
                    size="medium"
                  class="mian-list-info-right-tag" >{{model.isTransferOrder?'已转单':'待审核'}}</van-tag>
                  <van-tag type="success" class="mian-list-info-right-tag" v-if="model.isAudit==1" size="medium">已通过</van-tag>
                  <van-tag type="danger" class="mian-list-info-right-tag" v-if="model.isAudit==2" size="medium">已取消</van-tag>
              </div>
              <div class="mian-list-info-data">
                <span>充值金额:</span>
                <span>{{model.money}}</span>
            </div>
             <div class="mian-list-info-data">
                <span>单号:</span>
                <span>{{model.tid}}</span>
            </div>
             <div class="mian-list-info-data">
                  <span>划拨金额:</span>
                  <span>{{model.transferBalance}}</span>
            </div>
             <div class="mian-list-info-data">
                  <span>原始分销商:</span>
                  <span>{{model.originalDealerName}}</span>
            </div>
             <div class="mian-list-info-data">
                  <span>分销商:</span>
                  <span>{{model.dealerName}}</span>
            </div>
            </div>
         </div>
          <div class="mian-list-mark" v-if="model.comment">
              <div>备注:{{model.comment}}</div>
          </div>
         <div style="text-align:center" class="mian-list-btns" v-if="model.isAudit==0 && !model.isTransferOrder">
            <van-button type="primary" @click="auditRecharge(0)">转单上级</van-button>
           <!-- <van-button type="info" @click="auditRecharge(1)">划拨余额</van-button> -->
            <van-button type="danger" @click="auditRecharge(2)">取消订单</van-button>
        </div>
    </div>
    
     <van-popup v-model="popshow">
      <div class="info mz-proof">
        <div class="mz-proof-upload">
            <div class="mz-proof-upload">
                <van-uploader  upload-text="上传凭据" v-model="fileList" :max-count="1" :after-read="afterRead"  accept="image/*">
                </van-uploader>
            </div>
        </div>
      </div>
      <div class="mz-proof-btns">
        <van-button @click="Recharge()" round type="primary">转单上级</van-button>
      </div>
    </van-popup>
    <!-- <van-cell-group title="充值详情">
      <van-cell title="充值单号" :value="model.tid" />
      <van-cell title="充值金额" :value="model.money" />
      <van-cell title="划拨金额" :value="model.transferBalance" />
      <van-cell title="原始分销商" :value="model.originalDealerName" />
      <van-cell title="分销商" :value="model.dealerName" />
      <van-cell
        title="状态"
        :value="model.isTransferOrder?'已转单':model.isAudit==0?'待处理':model.isAudit==1?'已通过':'已取消'"
      />
      <van-cell title="大小货" :value="model.productTypeName" />
      <div style="text-align:center" v-if="model.isAudit==0 && !model.isTransferOrder">
        <van-button type="primary" @click="auditRecharge(0)">转单上级</van-button>
        <van-button type="info" @click="auditRecharge(1)">划拨余额</van-button>
        <van-button type="danger" @click="auditRecharge(2)">取消订单</van-button>
      </div>
    </van-cell-group> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      model: {
       
      },
      curproofpath:'',
      popshow:false,
      fileList:[],
      getparams: 
      {
          "ProductType":1,
          "sorting": "",
          "maxResultCount": 1,
          "skipCount": 0,
          "tid":''
      }

    };
  },
  methods: {
    queryorder(){
        this.ajax.post('/api/services/app/PhoneUser/QuerySubRechargeRecordPages', this.getparams).then(x => {
          this.model=x.result.items[0];
          });
    },
    auditRecharge(e) {
       //转上级需要凭证
      if(e==0)
      {
          this.curproofpath='';
          this.fileList=[];
          this.popshow=true;
      }else
      {
         this.tj(e,this.model);
      }

  },
  tj(e,item,filepath='')
    {
        
      this.ajax
        .post("/api/services/app/PhoneUser/AuditRecharge", {
          id: item.id,
          status: e,
          proofPath:filepath
        })
        .then(() => {
          //this.$toast.loading("正在执行中");
          this.popshow=false;
        });
    },
    afterRead(file){
        var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
　　    formData.append('file', file.file); //接口需要传的参数
        this.ajax
        .post("/File/SaveProofPic", formData)
        .then(x => {
           var imgurl= x.result.data[0];
            this.curproofpath=imgurl;
            console.log("打印图片路径:"+x);
        }).catch(()=>{
           this.$toast.fail({message:"上传失败,请重新上传"});
           this.curproofpath='';
        });
    },
    //转上级需要凭证
    Recharge(){
        if(this.fileList.length<1)
        {
            this.$toast.fail({title:'提示',message:'请先提交凭据'})
            return;
        }
        this.tj(0,this.model,this.curproofpath);
    }
  },
  created() {
      console.log(this.model);
      this.model = this.$route.params;
      this.getparams.tid= this.model.tid;
      this.abp.event.on("app.AuditRechargeRecord", (x) => {
        console.log(x);
        if (x.status != 0) {
          this.$dialog({ message: x.errMsg });
        } else {
          this.$toast.success(x.result);
          this.queryorder();
        }
      });
      this.abp.event.on("app.AuditAssist", (x) => {
        if (x.status != 0) {
          this.$dialog({ message: x.errMsg });
        } else {
          this.$toast.success(x.result);
          this.queryorder('refresh');
        }
      });
  }
};
</script>
<style lang="scss" scoped>
.mian-list{
  background-color: #fff;
  margin-top: 10px;
  font-size: 12px;
  border-radius: 8px;
  margin: 10px;
  padding: 10px;
  box-shadow: 1px 1px 4px #c3c3c3;
  word-break: break-all;
  line-height: 18px;
}
.mian-list-info{
  padding: 5px 0 5px 110px;
  font-size: 14px;
  position: relative;
  min-height: 100px;
  word-break: break-all;
}
.main-list-info-main{
  position:  relative;
}
.min-height
{
  min-height: 18px;
}
.mian-list-info-right{
  position: absolute;
  right: 0;
  width: 90px;
  text-align: right;
}
.mian-list-info-left-tag
{
  position: absolute;
  left:0 ;
}
.mian-list-info-right{
  position: absolute;
  right: 0;
  width: 90px;
  text-align: right;
}
.mian-list-info-right-tag{
  position: absolute;
  right: 0;
}
.mian-list-mark{
  border-top: 1px solid #e2e2e2;
  padding-top: 10px;
  font-size: 18px;
}
.mian-list-btns{
  margin-top: 20px;
  text-align: center;
}
.mian-list-btns button{
    margin-right: 10px;
    padding: 8px 20px;
    height: auto;
    border-radius: 34px;
    border: 0;
}
.mian-list-pic{
  position: absolute;
  top: 50%;
  left:0;
  width: 100px;
  height: 100px;
  transform: translate(0,-50%);
}
.mian-list-pic img{
  width: 100%;
  height: 100%;
}
.mian-list-pic img{
  width: 100%;
  height: 100%;
}
.info{
    position: relative;
    background-color: #fff;
    border-radius: 8px;
    margin: 20px 10px 10px 10px;
    font-size: 12px;
    width: 250px;
}
.mz-proof-btns{
  margin-bottom: 10px;
  text-align: center;
}
.mz-proof-btns button{
  margin-right: 10px;
  padding: 8px 20px;
  height: auto;
  border-radius: 34px;
  border: 0;
}

</style>
<style lang="scss" scoped>
.van-uploader__wrapper{
    width: 100%;
    display: block;
  }
  
  .van-uploader__upload{
    width: 100%;
  }
  .van-uploader{
    display: block;
  }
  .van-uploader__preview-image{
    width: 100%;
    height: 80px;
  }
  </style>